function PhoneInputMinNumberMsg() {
	
	return (
		'Phone number must be at least 8 characters'
	);
}

export default PhoneInputMinNumberMsg;